import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, Image, Container } from "react-bootstrap";
import { Document } from "react-pdf";
import { Page } from "react-pdf";

import CustomButton from "../../../components/UI/Button/Button";
import * as explanationOfBenefitsActions from "../../../store/actions/index.js";
import Modal from "../../../components/UI/Modal/Modal";
import BrowseImages from "./BrowseExplanationOfBenefits/BrowseExplanationOfBenefits";
import SubmitBills from "../SubmitBills/SubmitBills";
import ViewExplanationOfBenefits from "./ViewExplanationOfBenefits/ViewExplanationOfBenefits";
// import { useTranslation,withTranslation } from 'react-i18next';

import classes from "./ExplanationOfBenefits.module.css";

import dollar from "../../../assets/images/icon-dollar-small.svg";
import dynamicMessages from "../../../dynamicMessages";

interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {
  explanationOfBenefitsBills: File[];
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  balanceBillView: string;
  // t:any;
  t:any;
}
interface IDispatchFromProps {
  onRemoveFiles: (fileArray: File[]) => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
}
type Props = IStateFromProps & IDispatchFromProps & IParentProps;
class ExplanationOfBenefits extends Component<Props> {
  state = {
    explanationOfBenefitsUploaded: false,
    explanationOfBenefitsBillsUploading: false,
    explanationOfBenefitsBillsAvailable: true,
    viewingBills: false,
    viewBillNumber: 0,
    summaryOfBills: false,
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.explanationOfBenefitsBills.length !==
      prevProps.explanationOfBenefitsBills.length
    )
      if (this.props.explanationOfBenefitsBills.length > 0) {
        this.setState({ explanationOfBenefitsUploaded: true });
      } else {
        this.setState({ explanationOfBenefitsUploaded: false });
      }

      if (prevProps.balanceBillView !== this.props.balanceBillView) {
        console.log("inside if of getStarted");
        if (this.props.balanceBillView === "summaryOfBills") {
          this.setState({ summaryOfBills: true });
        } else if (this.props.balanceBillView === "notSummaryOfBills" || this.props.balanceBillView === "") {
          this.setState({ summaryOfBills: false });
        }
      }
  }

  uploadExplanationOfBenefitsHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: true });
  };
  explanationOfBenefitsUploadedHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: false });
  };
  onChangeFavorite = (event) => {
    console.log(event.target.checked, event.target.name);
    if (event.target.checked) {
      this.setState({ explanationOfBenefitsBillsAvailable: false });
    } else if (!event.target.checked) {
      this.setState({ explanationOfBenefitsBillsAvailable: true });
    }
  };
  viewingBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingBills: true });
  };
  closeViewingBillsHandler = () => {
    this.setState({ viewingBills: false });
  };

  deleteHandler = (index: number) => {
    var array = [...this.props.explanationOfBenefitsBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveFiles(array);
    }
  };
  // componentWillUnmount() {
  //   this.props.onRemoveFiles([]);
  // }

  summaryOfBillsHandler = () => {
    this.setState({ summaryOfBills: true });
  };

  summaryOfBillsBackHandler = () => {
    this.setState({ summaryOfBills: false });
  };
  goBackHandler = () => {
    this.props.onRemoveFiles([]);
    this.props.goBackHandler();
  };
  render() {
    const {t} = this.props;
    // const { goBackHandler } = { ...this.props };
    const nextBtnStyle = {
      minWidth: "150px",
    };

    const modalViewBillStyle = {
      width: "700px",
      left: "calc(50% - 350px)",
      top: "15%",
      position: "absolute",
    };

    const explanationOfBenefitsBillsUpload = (
      <Modal
        show={this.state.explanationOfBenefitsBillsUploading}
        childComp={
          <BrowseImages
            modalClosed={this.explanationOfBenefitsUploadedHandler}
          />
        }
        style={{}}
      />
    );

    let viewBills: any;
    if (this.state.viewingBills) {
      viewBills = (
        <Modal
          show={this.state.viewingBills}
          childComp={
            <ViewExplanationOfBenefits
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }
    const explanationOfBenefitsUploadedCount = (
      <div className="selectedFiles">
        <div>
          <span className="filesCount">
            {this.props.explanationOfBenefitsBills
              ? this.props.explanationOfBenefitsBills.length
              : "0"}
          </span>
          {t('uploadBill.billsUploaded')}
        </div>
      </div>
    );

    const explanationOfBenefitsBanner = (
      <div className="uploadList">
        {/* <strong> */}
        {this.props.config_values &&
        this.props.config_values.find(
          (ele) =>
            ele.targetPageTitle.toLowerCase() ===
              "Explanation of Benefits".toLowerCase() &&
            ele.element.toLowerCase() === "Description".toLowerCase()
        )
          ? this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Explanation of Benefits".toLowerCase() &&
                ele.element.toLowerCase() === "Description".toLowerCase()
            )?.customValue
            ? this.props.config_values
                .find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Explanation of Benefits".toLowerCase() &&
                    ele.element.toLowerCase() === "Description".toLowerCase()
                )
                ?.customValue?.split("\n")
                .map((item, key) => {
                  return (
                    <span key={key}>
                      {dynamicMessages(item)?t(dynamicMessages(item)):item}
                      <br />
                    </span>
                  );
                })
            : this.props.config_values
                .find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Explanation of Benefits".toLowerCase() &&
                    ele.element.toLowerCase() === "Description".toLowerCase()
                )
                ?.defaultValue?.split("\n")
                .map((item, key) => {
                  return (
                    <span key={key}>
                      {dynamicMessages(item)?t(dynamicMessages(item)):item}
                      <br />
                    </span>
                  );
                })
          : ``}
        {/* </strong> */}
        {/* <ul>
          <li>
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Explanation of Benefits".toLowerCase() &&
                ele.element.toLowerCase() === "Description".toLowerCase()
            )
              ? this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Explanation of Benefits".toLowerCase() &&
                    ele.element.toLowerCase() === "Description".toLowerCase()
                )?.customValue
                ? this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Explanation of Benefits".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                    ?.customValue?.split("\n")[1]
                : this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Explanation of Benefits".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                    ?.defaultValue.split("\n")[1]
              : `Ensure you upload your EOB only for this DOS and this provider.`}
          </li>

          <li>
            {this.props.config_values &&
            this.props.config_values.find(
              (ele) =>
                ele.targetPageTitle.toLowerCase() ===
                  "Explanation of Benefits".toLowerCase() &&
                ele.element.toLowerCase() === "Description".toLowerCase()
            )
              ? this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Explanation of Benefits".toLowerCase() &&
                    ele.element.toLowerCase() === "Description".toLowerCase()
                )?.customValue
                ? this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Explanation of Benefits".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                    ?.customValue?.split("\n")[2]
                : this.props.config_values
                    .find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Explanation of Benefits".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                    ?.defaultValue.split("\n")[2]
              : `Upload one quality image at a time.`}
          </li>
        </ul> */}
      </div>
    );

    let preview: any;
    if (
      this.props.explanationOfBenefitsBills &&
      this.props.explanationOfBenefitsBills.length > 0
    ) {
      preview = (
        <div className="uploadPreviews">
          {(this.props.explanationOfBenefitsBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() => this.viewingBillsHandler(index)}
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() => this.viewingBillsHandler(index)}
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }
    let submitBills: any;
    if (this.state.summaryOfBills) {
      submitBills = <SubmitBills t={t} />;
    } else {
      submitBills = (
        <Container fluid>
          {explanationOfBenefitsBillsUpload}
          {viewBills}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t('balanceBilling.balanceBilling')}</h3>
              <Image
                src={dollar}
                alt="stock-image"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
          </div>
          <div className="mainContainer">
            <div className="text-center">
              <h6 className="bill-heading">{t('uploadBill.newUpload')}</h6>
              <div className="step-circles">
                <ul>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="select"></li>
                  <li></li>
                </ul>
              </div>
              <div className="bb-text">
                <strong>
                  {this.props.documentTypes.length > 0 &&
                    this.props.documentTypes.find((title) => title.order === 4)
                      ?.type}
                </strong>
                <p>
                  {this.props.config_values &&
                  this.props.config_values.find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Explanation of Benefits".toLowerCase() &&
                      ele.element.toLowerCase() === "header".toLowerCase()
                  )
                    ? this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Explanation of Benefits".toLowerCase() &&
                            ele.element.toLowerCase() === "header".toLowerCase()
                        )
                        ?.customValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)?t(dynamicMessages(item)):item}
                              <br />
                            </span>
                          );
                        })
                    : this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Explanation of Benefits".toLowerCase() &&
                            ele.element.toLowerCase() === "header".toLowerCase()
                        )
                        ?.defaultValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {dynamicMessages(item)?t(dynamicMessages(item)):item}
                              <br />
                            </span>
                          );
                        })}
                </p>
              </div>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="customSwitches"
                  onChange={this.onChangeFavorite}
                />
                <span className="switchUnChecked">{t('uploadBill.yes')}</span>
                <label
                  className="custom-control-label"
                  htmlFor="customSwitches"
                ></label>
                <span className="switchChecked">No</span>
              </div>
            </div>
            {this.state.explanationOfBenefitsUploaded &&
              explanationOfBenefitsUploadedCount}
            {!this.state.explanationOfBenefitsUploaded &&
              explanationOfBenefitsBanner}
            {preview}

            <div className="text-center">
              {/* {!this.state.explanationOfBenefitsUploaded && (
                <h5 className="text-grey m-b-25">
                  Upload Explanation of Benefits
                </h5>
              )} */}
              <Button
                className="btn-lg-border"
                onClick={this.uploadExplanationOfBenefitsHandler}
                disabled={
                  this.state.explanationOfBenefitsBillsAvailable ? false : true
                }
              >
                <span>
                  {this.state.explanationOfBenefitsUploaded
                    ? t('submitBill.addMore')
                    : `${t('balanceBilling.uploadBtn')} ${
                        this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 4
                        )?.type
                      }`}
                </span>
                <i>+</i>
              </Button>
            </div>

            <div className="flexButtons">
              <CustomButton
                label={t('uploadBill.back')}
                clicked={this.goBackHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <CustomButton
                label={t('uploadBill.next')}
                clicked={this.summaryOfBillsHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={
                  false
                  // this.state.explanationOfBenefitsUploaded &&
                  // this.state.explanationOfBenefitsBillsAvailable
                  //   ? false
                  //   : true
                }
              />
            </div>
          </div>
        </Container>
      );
    }
    return <Fragment>{submitBills}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  explanationOfBenefitsBills: state.browseImages.explanationOfBenefitsBills,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  config_values: state.appConfig.config_values,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onRemoveFiles: (explanationOfBenefitsBills) =>
    dispatch(
      explanationOfBenefitsActions.explanationOfBenefitsBills(
        explanationOfBenefitsBills
      )
    ),
    onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(
      explanationOfBenefitsActions.setBalanceBillViewState(balanceBillView)
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExplanationOfBenefits);
